"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var state_1 = require("./state");
var pkg_frontend_vuex_multi_cabins_item_1 = require("pkg-frontend-vuex-multi-cabins-item");
var pkg_frontend_vuex_checkout_1 = require("pkg-frontend-vuex-checkout");
var pkg_frontend_vuex_booking_general_1 = require("pkg-frontend-vuex-booking-general");
var allAgeGroups_1 = require("./getters/allAgeGroups");
var allPaxes_1 = require("./getters/allPaxes");
var allBuyerPaxes_1 = require("./getters/allBuyerPaxes");
var currencyConversionPrice_1 = require("./getters/currencyConversionPrice");
var hasInsurance_1 = require("./getters/hasInsurance");
var totalInsurance_1 = require("./getters/totalInsurance");
var totalPrice_1 = require("./getters/totalPrice");
var userSelectedPriceModel_1 = require("./getters/userSelectedPriceModel");
var apiBookData_1 = require("./getters/apiBookData");
var parsedStore_1 = require("./helper/parsedStore");
// features
var ajaxManagement_1 = require("./feature/ajaxManagement");
var cabinManagement_1 = require("./feature/cabinManagement");
var currencyManagement_1 = require("./feature/currencyManagement");
var wizard_1 = require("./feature/wizard");
var MultiCabins = /** @class */ (function () {
    // create everything
    function MultiCabins(namespace) {
        // resolve namespacing, applies "foo/bar/..." stuff automatically
        this.namespaced = true;
        this.actions = __assign(__assign(__assign(__assign({}, parsedStore_1.default.actions), cabinManagement_1.default.actions), currencyManagement_1.default.actions), wizard_1.default.actions);
        this.getters = __assign(__assign(__assign(__assign(__assign(__assign({}, ajaxManagement_1.default.getters), cabinManagement_1.default.getters), currencyManagement_1.default.getters), parsedStore_1.default.getters), wizard_1.default.getters), { allAgeGroups: allAgeGroups_1.default,
            allBuyerPaxes: allBuyerPaxes_1.default,
            allPaxes: allPaxes_1.default,
            apiBookData: apiBookData_1.apiBookData,
            currencyConversionPrice: currencyConversionPrice_1.default,
            hasInsurance: hasInsurance_1.default,
            totalInsurance: totalInsurance_1.default,
            totalPrice: totalPrice_1.default,
            userSelectedPriceModel: userSelectedPriceModel_1.default });
        this.mutations = __assign(__assign(__assign(__assign(__assign({}, ajaxManagement_1.default.mutations), cabinManagement_1.default.mutations), currencyManagement_1.default.mutations), parsedStore_1.default.mutations), wizard_1.default.mutations);
        this.modules = {
            checkout: new pkg_frontend_vuex_checkout_1.Checkout(),
            general: new pkg_frontend_vuex_booking_general_1.BookingGeneral(),
            cabin1: null,
            cabin2: null,
            cabin3: null,
            cabin4: null,
        };
        this.state = new state_1.State();
        this.modules.cabin1 = new pkg_frontend_vuex_multi_cabins_item_1.MultiCabinsItem(namespace + '/cabin1');
        this.modules.cabin2 = new pkg_frontend_vuex_multi_cabins_item_1.MultiCabinsItem(namespace + '/cabin2');
        this.modules.cabin3 = new pkg_frontend_vuex_multi_cabins_item_1.MultiCabinsItem(namespace + '/cabin3');
        this.modules.cabin4 = new pkg_frontend_vuex_multi_cabins_item_1.MultiCabinsItem(namespace + '/cabin4');
        this.modules.cabin2.modules.pax.mutations.UNSET_BUYER(this.modules.cabin2.modules.pax.state);
        this.modules.cabin3.modules.pax.mutations.UNSET_BUYER(this.modules.cabin3.modules.pax.state);
        this.modules.cabin4.modules.pax.mutations.UNSET_BUYER(this.modules.cabin4.modules.pax.state);
    }
    return MultiCabins;
}());
exports.MultiCabins = MultiCabins;
//# sourceMappingURL=index.js.map